import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import Avatar from '@material-ui/core/Avatar'
import DeleteIcon from '@material-ui/icons/Delete'
import IconButton from '@material-ui/core/IconButton'
import { Checkbox } from 'antd'
import { getQuantityLabel } from '../../utils'

export const ProductList = ({ items, setDeleteProduct, checklist, setModal ,onChange,productIdList }) => {
  const checkedValue = (item) => {
    return _.some(productIdList, (id) => {
      return item.material.id === id
    })
  }

  return (
    <List component="nav">
      {items &&
      items.map((item, index) => {
        return (
          <div key={`product-item-${index.toString()}`}>
            <ListItem
              key={item.id}
              button
              onClick={() => {
                setModal({ open: true, data: item })
              }}
            >
              <ListItemIcon>
                <Avatar
                  src={item.material.cover && item.material.cover.url}
                />
              </ListItemIcon>
              <ListItemText
                primary={item.material.name}
                secondary={getQuantityLabel(item.minQuantity)}
              />
              <ListItemSecondaryAction>
                {checklist ? (
                  <Checkbox onChange={onChange} value={item.material.id} checked={checkedValue(item)} />
                ) : (
                  <IconButton
                    id="btnDelete"
                    color="default"
                    aria-label="Menu"
                    onClick={() => setDeleteProduct(item.id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                )}
              </ListItemSecondaryAction>
            </ListItem>
          </div>
        )
      })}
    </List>
  )
}

ProductList.propTypes = {
  items: PropTypes.array.isRequired,
  productIdList: PropTypes.array.isRequired,
  setDeleteProduct: PropTypes.func.isRequired,
  setModal: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  checklist: PropTypes.bool
}

ProductList.defaultProps = {
  checklist: false
}

export default ProductList



// WEBPACK FOOTER //
// ./src/components/ProductList/index.js